<div class="responseWrapper">
  <fieldset class="responseFields">
    <legend>Heating Conditions</legend>
    <div>
      <label class="configurationInputLabel">Total Capacity:</label>
      <input readonly="readonly" [value]="heatingTotalCapacity" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getCapacityUnits() }}</label>
    </div>
    <div class="configurationDetailRow">
      <label class="configurationInputLabel">Leaving Dry Bulb:</label>
      <input readonly="readonly" [value]="heatingLeavingDryBulb" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
    <div class="configurationDetailRow">
      <label class="configurationInputLabel">Fluid Flow Rate:</label>
      <input readonly="readonly" [value]="heatingFluidFlowRate" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getFluidFlowUnits() }}</label>
    </div>
    <div class="configurationDetailRow">
      <label class="configurationInputLabel">Fluid Temp Change:</label>
      <input readonly="readonly" [value]="heatingFluidTemperatureChange" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
    <div class="configurationDetailRow">
      <label class="configurationInputLabel">Leaving Fluid Temp:</label>
      <input readonly="readonly" [value]="heatingLeavingFluidTemperature" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
    <div class="configurationDetailRow">
      <label class="configurationInputLabel">Fluid Press Drop</label>
      <input readonly="readonly" [value]="heatingFluidPressureDrop" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getPressureDropUnits() }}</label>
    </div>
  </fieldset>
  <fieldset class="responseFields">
    <legend>Electric Heating</legend>
    <div>
      <label class="configurationInputLabel">Leaving Dry Bulb:</label>
      <input readonly="readonly" [value]="electricHeatLeavingDryBulb" class="configurationRatingValueOutput">
      <label class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</label>
    </div>
  </fieldset>
</div>
<div class="footer">
  Ratings may be impacted by the inclusion of SFRs for certain components. Please review with your RSM if you have any questions.
</div>
